import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const styled = { createGlobalStyle }

// fix 无法自动格式化 https://github.com/styled-components/vscode-styled-components/issues/175
const GlobalStyle = styled.createGlobalStyle`
  :root {
    --theme-base-safe-area: env(safe-area-inset-bottom);
  }

  /* font */
  * {
    font-family: 'IBM Plex Sans', sans-serif !important;
    /* font-family: 'IBM Plex Sans', 'Poppins', sans-serif !important; */
  }

  /* flex */
  .flex {
    display: flex;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-col {
    flex-direction: column;
  }

  .items-start {
    align-items: flex-start;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-center {
    align-items: center;
  }
  .items-stretch {
    align-items: stretch;
  }

  .justify-start {
    justify-content: flex-start;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }

  .row-start {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .row-center {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .row-between {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .row-end {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .col-start {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .col-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .col-between {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .col-end {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  /* flex */

  /* --------------------------------------------- */
  /* ----------------  触控样式  ------------------ */
  /* --------------------------------------------- */
  .hover {
    user-select: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      opacity: 0.6;
    }
    &:active {
      opacity: 0.6;
    }
  }

  hr {
    margin: 0;
    border: none;
  }

  .newSetting {
    background-color: #292929;
  }

  html {
    overflow-x: hidden;
  }

  body {
    /* background-color: ${({ theme }) => theme.colors.background}; */
    background-color: #000000;

    .swapBox {
      & > div {
        background-color: rgba(47, 40, 40, 0.5);
        border: 1px solid rgba(233, 129, 96, 0.35);
      }
    }

    img {
      height: auto;
      max-width: 100%;
    }
    .increaseLiquidity {
      #add-liquidity-input-tokena,
      #add-liquidity-input-tokenb {
        background: rgba(255, 255, 255, 0.08) !important;
        label {
          background: transparent !important;
        }
      }
    }
  }

  .no-select {
    user-select: none;
  }
`

export default GlobalStyle
